import type { ComponentPropsWithRef } from 'react';

import { clsx } from '~/styles/utils';

import { Icon } from '../Icon/Icon';
import { getSharedButtonClassNames, type SharedButtonProps } from './Button.utils';

type Props = ComponentPropsWithRef<'a'> & SharedButtonProps;

export const ExternalLinkButton = (props: Props) => {
  const { children, emphasis, icon, iconPlacement, target, ...delegated } = props;

  return (
    <a
      {...delegated}
      className={clsx(getSharedButtonClassNames({ children, emphasis, icon, iconPlacement }), delegated.className)}
      rel={delegated.rel ?? 'noreferrer'}
      target={target ?? '_blank'}
    >
      {icon && <Icon name={icon} size={22} />}
      {children}
    </a>
  );
};
